import { useEffect, useState } from 'react';
import { Alert, Collapse, Box, Typography, IconButton } from '@mui/material';
import { WifiOff, Wifi, Close } from '@mui/icons-material';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';
import { en } from '../../locale';

/**
 * Bannière affichant le statut de la connexion réseau
 * S'affiche automatiquement lorsque l'utilisateur perd la connexion
 */
export default function NetworkStatusBanner() {
  const isOnline = useNetworkStatus();
  const [dismissed, setDismissed] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
      setDismissed(false);
    }
  }, [isOnline]);

  // Afficher une notification de reconnexion pendant 3 secondes
  useEffect(() => {
    if (isOnline && wasOffline && !dismissed) {
      const timer = setTimeout(() => {
        setDismissed(true);
        setWasOffline(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline, dismissed]);

  const showBanner = !dismissed && (!isOnline || (isOnline && wasOffline));

  return (
    <Collapse in={showBanner}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
        }}
      >
        <Alert
          severity={isOnline ? 'success' : 'warning'}
          icon={isOnline ? <Wifi /> : <WifiOff />}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setDismissed(true)}
            >
              <Close fontSize="inherit" />
            </IconButton>
          }
          sx={{
            borderRadius: 0,
            alignItems: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {isOnline ? en.network.backOnline : en.network.offline}
          </Typography>
        </Alert>
      </Box>
    </Collapse>
  );
}
